const safeParse = (json) => {
  try {
    return JSON.parse(json);
  } catch (e) {
    return {};
  }
};

export default safeParse;
